import React from "react";
import { TrendingUp, MapPin } from "lucide-react";
import { CASE_STUDIES } from "../data/constants";

/**
 * Compact case studies grid — placeholder data. Swap CASE_STUDIES in /src/data/constants.js
 * when real numbers are ready.
 */
export const CaseStudies = ({ title = "Real Results From Real Businesses" }) => {
  return (
    <section className="section-padding bg-white" data-testid="case-studies-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-gray-dark mb-4">
            {title}
          </h2>
          <p className="text-gray-medium max-w-2xl mx-auto text-lg">
            Snapshots of how SmartReach™ moves the metrics that matter.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {CASE_STUDIES.map((cs) => (
            <div
              key={cs.id}
              className="relative overflow-hidden bg-gradient-to-br from-orange-light to-white rounded-2xl p-8 border border-orange-primary/10 card-hover"
              data-testid={`case-study-${cs.id}`}
            >
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="inline-flex items-center gap-1 text-xs font-semibold text-orange-primary bg-white px-3 py-1 rounded-full">
                  {cs.industry}
                </span>
                <span className="inline-flex items-center gap-1 text-xs font-medium text-gray-medium bg-white px-3 py-1 rounded-full">
                  <MapPin size={12} /> {cs.location}
                </span>
              </div>
              <h3 className="font-display font-bold text-xl md:text-2xl text-gray-dark mb-3 leading-snug">
                {cs.headline}
              </h3>
              <p className="text-gray-medium mb-6">{cs.summary}</p>
              <div className="grid grid-cols-3 gap-4 pt-6 border-t border-orange-primary/10">
                {cs.stats.map((s, idx) => (
                  <div key={idx}>
                    <div className="text-xl md:text-2xl font-display font-bold text-orange-primary flex items-center gap-1">
                      <TrendingUp size={18} />
                      {s.value}
                    </div>
                    <div className="text-xs text-gray-medium mt-1">{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-xs text-gray-medium/70 mt-6 italic">
          * Illustrative case studies — pending client approval to publish full versions.
        </p>
      </div>
    </section>
  );
};

export default CaseStudies;
